/**
 * Sets feature flags for the application for the
 * current user, using localStorage
 * Togglable in the debugger toolbar (press cmd+db)
 */
import React, { createContext } from '../../_snowpack/pkg/react.js';
import { useLocalStorage } from '../hooks/index.js';
export const FeatureFlagsState = /*#__PURE__*/createContext({
  applicationPlugins: false,
  atomPlanPreview: false
});
export const FeatureFlagsActions = /*#__PURE__*/createContext({
  setApplicationPlugins: a => {
    // eslint-disable-next-line no-console
    console.log(a);
    return;
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setAtomPlanPreview: a => {
    // eslint-disable-next-line no-console
    console.log(a);
    return;
  }
});
export function FeatureFlagsGate({
  children
}) {
  const [applicationPlugins, setApplicationPlugins] = useLocalStorage('featureFlag:applicationPlugins', false);
  const [atomPlanPreview, setAtomPlanPreview] = useLocalStorage('featureFlag:atomPlanPreview', false);
  const state = {
    applicationPlugins,
    atomPlanPreview
  };
  const actions = {
    setApplicationPlugins,
    setAtomPlanPreview
  };
  return /*#__PURE__*/React.createElement(FeatureFlagsState.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(FeatureFlagsActions.Provider, {
    value: actions
  }, children));
}